module.exports = __webpack_public_path__ + "static/smartboost-ea3efc78b04ec6ab6830f29dfcac5282.jpg";